import { ReactNode, useEffect } from "react";
import { Heading } from "src/api/sure-api/ssq/useGetOneSsq";
import { QuestionnairesList } from "src/components/QuestionnairesList/QuestionnairesList";
import { ANSWER_SSQ, PRODUCT, useFoodpilotContext } from "src/context/FoodpilotContext";
import { URLHandler } from "src/services/URLHandler";
import { useGetProductPost } from "src/api/client-api/post/useGetProductPost";
import { useProductContext } from "../ProductContext";
import { ScoreChart } from "src/components/ScoreChart/ScoreChart";
import { buildChartValues } from "src/utils/buildScoreChartValues";
import { ExportSSQExcelButton } from "src/components/Button/ExportExcelSSQButton";
import { useTranslation } from "react-i18next";

export const DIMENSION = "headings";

export const Questionnaire = (): ReactNode => {
    const {
        product,
        ssq,
        isSsqLoading,
        switchToDimension,
        selectedScore,
        allScoreWithVariations,
        isLoading,
        isRefetching,
    } = useProductContext();
    const { selectedCompany, currentCampaign, canUser } = useFoodpilotContext();
    const companyId = selectedCompany ? selectedCompany.id : null;
    const { post, isLoading: isPostLoading } = useGetProductPost(product?.id, companyId, currentCampaign?.id);
    const selectedScoreId = selectedScore?.scoreId;
    const score = product?.scores[selectedScoreId];
    const dimensionScores = score?.dimensions.filter((d) => d.label === DIMENSION).map((d) => d.values);
    const { t } = useTranslation();

    useEffect(() => {
        switchToDimension(DIMENSION);
    }, []);

    if (!product) return null;
    if (selectedCompany === null) return;

    const chartValues = buildChartValues(dimensionScores);

    return (
        <>
            <ExportSSQExcelButton label={t("ssq.export.excel.button.label")} ssq={ssq} post={post} />
            <QuestionnairesList
                ssq={ssq}
                post={post}
                isSsqLoading={isSsqLoading}
                isPostLoading={isPostLoading}
                displayDateLastModified={false}
                completeQuestionnaireUrl={(heading: Heading) => {
                    const url = URLHandler.product.ssqHeading(selectedCompany.id, product.id, heading.id);
                    return url;
                }}
                scoresSection={
                    <ScoreChart
                        allScoreWithVariations={allScoreWithVariations}
                        selectedScore={selectedScore}
                        totalScore={chartValues.totalScore}
                        data={chartValues}
                        isLoading={isLoading}
                        isRefetching={isRefetching}
                    />
                }
                enableTableHead={false}
                muiTableProps={{
                    sx: {
                        border: "none",
                    },
                }}
                tableMode="extended"
                canEdit={canUser(ANSWER_SSQ, PRODUCT)}
            />
        </>
    );
};
